// extracted by mini-css-extract-plugin
export default {"section_container":"PrivateLayout_section_container__k-lq-","footer_desktop":"PrivateLayout_footer_desktop__B52u7","footer_mobile":"PrivateLayout_footer_mobile__L1biJ"};